module.exports = __webpack_public_path__ + "static/media/2014 - 2015 theme logo.449be9c7.jpg";